<template>
    <router-view></router-view>
</template>

<script>
    export default {
        data() {
            return {}
        },
        created() {


        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Muhasebe/gider.vue